<template>
  <el-card shadow="always" v-loading="loading" :body-style="{ padding: '0px' }">
    <div class="row bg-casper py-2 px-3">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="mb-0 text-white">Producers</h3>
      </div>
    </div>
    <div class="row m-4 ">
      <div class="col-12">
        <!--/businesses/create-->
        <el-table :data="businesses.data" style="width: 100%" cell-class-name="bg-lightgrey py-1">
          <el-table-column label="Name" prop="name">
            <template slot-scope="scope">
              <a :href="`/businesses/${scope.row.id}`" class="text-navy">{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column label="" prop="id" width="270">
            <template slot-scope="scope">
              <a :href="`/businesses/${scope.row.id}`" class="text-navy">
                <i class="far fa-sign-in-alt fa-lg p-2"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>
        <div class="py-3 d-flex justify-content-center justify-content-xl-end">
          <el-pagination small layout="prev, pager, next, total" :current-page.sync="currentPage"
            @current-change="handleCurrentChange" :background="true" :page-size="perPage"
            :page-count="businesses.last_page" :total="businesses.total" />
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import OttleyFormatter from "../../../mixins/OttleyFormatter";
import Business from "../../modelsPortal/Business";
export default {
  mixins: [OttleyFormatter],
  props: {
  },
  mounted() {
    this.getBusinesses();
  },
  data() {
    return {
      businesses: [],
      loading: false,
      statementModalShow: false,
      formModalShow: false,
      purchaseFormModalShow: false,
      selectedBusiness: null,
      page: 1,
      currentPage: 1,
      perPage: 5,
      showModal: false,
      selectedBusiness: null,
    };
  },
  methods: {
    getBusinesses(
      page = 1,
    ) {
      this.loading = true;

      let businesses = Business.page(page)
        .select('id', 'name')
        .params({ 'per_page': 10 });

      businesses
        .get()
        .then((res) => {
          this.loading = false;
          this.businesses = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
  },
};
</script>
